import React, { useState } from "react";
import "../../style/ViewJobModal.css";
import CloseIcon from "@mui/icons-material/Close";

const ViewJobModal = ({ isOpen, event, onClose, onDelete, onEdit }) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  if (!isOpen) return null;
  if (!event) return null;

  console.log("ViewJobModal rendering with event:", event);

  const handleDeleteClick = () => {
    setShowDeleteConfirmation(true);
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirmation(false);
  };

  const handleConfirmDelete = () => {
    console.log("Deleting job with ID:", event.id);
    onDelete(event.id);
    setShowDeleteConfirmation(false);
  };

  const handleEdit = () => {
    onEdit(event);
  };

  // Format date if it exists
  const formatDate = (dateStr) => {
    if (!dateStr) return "Not specified";

    try {
      // Parse the date
      const dateParts = dateStr.split("-");
      if (dateParts.length !== 3) return dateStr;

      return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateStr;
    }
  };

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const renderDescription = () => {
    const description = event.description || "Not specified";

    if (description.length <= 200 || showFullDescription) {
      return (
        <>
          <div className="description-content">{description}</div>
          {description.length > 200 && (
            <button className="show-toggle-button" onClick={toggleDescription}>
              Show Less
            </button>
          )}
        </>
      );
    } else {
      return (
        <>
          <div className="description-content">
            {description.substring(0, 200)}...
          </div>
          <button className="show-toggle-button" onClick={toggleDescription}>
            Show More
          </button>
        </>
      );
    }
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          <div className="modal-header">
            <h2>{event.title || "Job Details"}</h2>
            <CloseIcon className="close-icon" onClick={onClose} />
          </div>
          <div className="modal-body">
            <p>
              <strong>Job Position:</strong>{" "}
              {event.job_position || "Not specified"}
            </p>
            <p>
              <strong>Date:</strong> {formatDate(event.event_date)}
            </p>
            <p>
              <strong>Time:</strong> {event.event_time || "Not specified"}
            </p>
            <p>
              <strong>Location:</strong> {event.location || "Not specified"}
            </p>
            <div className="description-container">
              <strong>Description:</strong>
              {renderDescription()}
            </div>
            {event.link && (
              <p>
                <strong>Job Link:</strong>{" "}
                <a href={event.link} target="_blank" rel="noopener noreferrer">
                  View Job Posting
                </a>
              </p>
            )}
          </div>
          <div className="modal-footer">
            <button className="edit-button" onClick={handleEdit}>
              Edit Job
            </button>
            <button className="delete-button" onClick={handleDeleteClick}>
              Delete Job
            </button>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Popup */}
      {showDeleteConfirmation && (
        <div className="confirmation-overlay">
          <div className="confirmation-popup">
            <div className="confirmation-header">
              <h3>Confirm Deletion</h3>
              <CloseIcon className="close-icon" onClick={handleCancelDelete} />
            </div>
            <div className="confirmation-body">
              <p>Are you sure you want to delete this job application?</p>
              <p className="confirmation-job-title">
                <strong>{event.title}</strong> - {event.job_position}
              </p>
            </div>
            <div className="confirmation-footer">
              <button className="cancel-button" onClick={handleCancelDelete}>
                Cancel
              </button>
              <button
                className="confirm-delete-button"
                onClick={handleConfirmDelete}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewJobModal;